<template>
  <div v-if="service_groups.length">
    <section class="section services-all">
      <accordion-block
        title="Tutti i servizi"
        :collapse_id="'accordion-services-all-'+_uid"
      >
        <b-row>
          <b-col>
            <dl class="services-all__list" v-for="(group, group_index) in service_groups" :key="_uid+'group'+group_index">
              <dt class="services-all__title" v-if="group.label">{{ group.label }}</dt>
              <dd
                class="services-all__list-item"
                v-for="(service, service_index) in group.items" :key="_uid+service_index"
              >
                <vb-icon
                  :name="'check'"
                  :size="12"
                  class="services-all__list-icon"
                />
                  <span class="d-inline-block align-middle">{{ service.name }}</span>
              </dd>
            </dl>
          </b-col>
        </b-row>
      </accordion-block>
    </section>
  </div>
</template>

<script>
import AccordionBlock from './accordion-block.vue'

export default {
  inheritAttrs: false,
  name: 'services-all',

  components: {
    'accordion-block': AccordionBlock,
  },

  props: {
    statics_detail: { type: Object, default: null },
    product_detail: { type: Array, default: null },
    hotel_data: { type: Object, default: null },
  },

  computed: {

    service_groups() {
      // only-stay: amenities già raggruppate per label
      if (this.hotel_data && this.hotel_data.data && this.hotel_data.data.amenities) {
        return this.hotel_data.data.amenities
      }

      // flight-and-stay: lista piatta, un gruppo senza label
      if (this.product_detail && this.product_detail.length > 0 && this.statics_detail) {
        const product = this.product_detail[0]
        const statics = this.statics_detail[product.baseProdotto.pid]
        const services = statics
          && statics.schedaProdotto
          && statics.schedaProdotto.caratteristiche_prodotto
          && statics.schedaProdotto.caratteristiche_prodotto.known
          && statics.schedaProdotto.caratteristiche_prodotto.known.lista_servizi
        if (services) {
          return [{ label: '', items: services.map(s => ({ name: s.nome })) }]
        }
      }

      return []
    },
  },
}
</script>

<style lang="scss">

  .services-all {
    &.section {
      margin-top: $grid-gutter-20;
      margin-bottom: 0;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 0;
    }

    &__list {
      list-style: none;
      padding: 0;
      margin-bottom: $grid-gutter-width / 2;

      &:last-child {
        margin-bottom: 0;
      }

      &-icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }

      &-item {
        display: inline-block;
        margin-right: 15px;
        line-height: 3rem;
        margin-bottom: 0;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

</style>